// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.erl-chat {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 26;
}

.erl-chat .chat-window {
    position: fixed;
    min-height: 100px;
    border-radius: 4px;
    right: 3%;
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.5s ease, visibility 0.5s ease, left 0.5s ease;
    z-index: 1;
    background-color: #a21236;
    color: white;
    border: 0;
    bottom: 20px;
    width: 84%;
    left: calc(30px + 5%);
    overflow: auto;
    max-height: 75vh;
}

.erl-chat .destination-details-message {
    text-align: center;
}

.erl-chat .chat-content {
    padding: 15px;
}

.erl-chat .chat-background {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: fixed;
    background-color: #2d2d2dab;
    transition: background-color 0.5s ease;
}

#top .erl-chat .cont_input input {
    margin-top: 15px;
    width: 100%;
    text-align: left;
    margin-bottom: 5px;
    font-size: 18px;
    padding: 12px;
}

#top .erl-chat textarea {
    margin-top: 5px;
    width: 100%;
    height: 100px;
    min-height: 100px;
    resize: vertical;
    margin-bottom: 5px;
    font-size: 18px;
    padding: 12px;
}

.erl-chat .chat-success {
    margin: 50px 0;
}

.erl-chat .chat-header {
    padding: 5px 10px;
    overflow: hidden;
}

.erl-chat .btn.white {
    font-size: 13px;
    line-height: 13px;
    background-color: transparent;
    border: 2px solid white;
    padding: 11px 18px;
    margin-top: 20px;
    color: white;
}

.erl-chat .chat-sidebar, .erl-chat .dest-select-window {
    width: 42px;
    background-color: #a21236;
    min-height: 50px;
    position: absolute;
    border-radius: 0 4px 4px 0;
    bottom: 15%;
    top: auto;
    transition: transform 0.5s ease;
}

.erl-chat .chat-sidebar.chat-hidden {
    transform: translateX(-76%);
    cursor: pointer;
}

.erl-chat .chat-icon {
    opacity: .95;
    transition: transform 0.2s ease;
}

.erl-chat .chat-icons {
    padding: 10px;
}

.erl-chat .chat-icon:hover {
    opacity: 1;
    transform: scale(1.15);
    position: relative;
}

.erl-chat .chat-icon, .erl-chat .chat-icon a {
    color: white;
    padding: 5px 0;
    cursor: pointer;
}

.erl-chat .chat-icon-message {
    font-size: 21px;
}

.erl-chat .chat-window.show-chat-window {
    visibility: visible;
    opacity: 1;
}

.erl-chat .chat-icon .right-icon {
    display: none;
}


.erl-chat .error {
    color: white;
    font-size: 16px;
    margin-bottom: 15px;
}

.erl-chat .dest-select-window {
    background-color: #a21236;
    position: absolute;
    width: 300px;
    display: block;
    right: -250px;
    color: white;
    padding: 15px;
    left: 50px;
    border-radius: 4px;
    visibility: hidden;
    opacity: 0;
    transition: all .3s ease;
    max-height: calc(100vh - 100px);
    bottom: 20px;
    overflow: auto;
}

.erl-chat .chat-destination .info-line, .erl-chat .destination-details .info-line {
    padding: 5px;
    transition: all .3s ease;
    background-color: rgba(255, 242, 242, 0);
    border-radius: 4px;
}

.erl-chat .chat-destination:hover .info-line, .erl-chat .destination-details:hover .info-line {
    background-color: rgba(255, 242, 242, 0.2);
}

.erl-chat .dest-select-window.show-dest-select-window {
    visibility: visible;
    opacity: 1;
}

.erl-chat .dest-link {
    text-decoration: none;
    color: white;
    font-weight: normal;
}

@media screen and (min-width: 990px) {
    .erl-chat {
        position: fixed;
        left: unset;
        top: 0;
        right: 0;
        z-index: 501;
    }

    .erl-chat .chat-sidebar, .erl-chat .dest-select-window {
        border-radius: 4px 0 0 4px;
        top: 50%;
        transform: translate(-100%, -50%);
        bottom: unset;
    }

    .erl-chat .dest-select-window {
        left: auto;
        right: -250px;
        border-radius: 4px;
    }

    .erl-chat .chat-sidebar.chat-hidden {
        transform: translate(-20%, -50%);
        cursor: pointer;
    }

    .erl-chat .chat-window {
        min-width: 400px;
        width: 100%;
        left: -410px;
        top: -60px;
        bottom: unset;
        max-height: 93vh;
    }

    .erl-chat .dest-select-window {
        bottom: auto;
        max-height: calc(100vh - 100px);
        overflow: auto;
        position: fixed;
    }

    #top .avia-slideshow-arrows a.next-slide {
        right: 45px;
    }

    .erl-chat .chat-icon .right-icon {
        display: block;
    }

    .erl-chat .chat-icon .left-icon {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./../css/chat-sidebar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mEAAmE;IACnE,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,eAAe;IACf,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,YAAY;IACZ,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,MAAM;QACN,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;QACR,iCAAiC;QACjC,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,UAAU;QACV,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,+BAA+B;QAC/B,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".erl-chat {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 26;\n}\n\n.erl-chat .chat-window {\n    position: fixed;\n    min-height: 100px;\n    border-radius: 4px;\n    right: 3%;\n    min-width: 200px;\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.5s ease, visibility 0.5s ease, left 0.5s ease;\n    z-index: 1;\n    background-color: #a21236;\n    color: white;\n    border: 0;\n    bottom: 20px;\n    width: 84%;\n    left: calc(30px + 5%);\n    overflow: auto;\n    max-height: 75vh;\n}\n\n.erl-chat .destination-details-message {\n    text-align: center;\n}\n\n.erl-chat .chat-content {\n    padding: 15px;\n}\n\n.erl-chat .chat-background {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    position: fixed;\n    background-color: #2d2d2dab;\n    transition: background-color 0.5s ease;\n}\n\n#top .erl-chat .cont_input input {\n    margin-top: 15px;\n    width: 100%;\n    text-align: left;\n    margin-bottom: 5px;\n    font-size: 18px;\n    padding: 12px;\n}\n\n#top .erl-chat textarea {\n    margin-top: 5px;\n    width: 100%;\n    height: 100px;\n    min-height: 100px;\n    resize: vertical;\n    margin-bottom: 5px;\n    font-size: 18px;\n    padding: 12px;\n}\n\n.erl-chat .chat-success {\n    margin: 50px 0;\n}\n\n.erl-chat .chat-header {\n    padding: 5px 10px;\n    overflow: hidden;\n}\n\n.erl-chat .btn.white {\n    font-size: 13px;\n    line-height: 13px;\n    background-color: transparent;\n    border: 2px solid white;\n    padding: 11px 18px;\n    margin-top: 20px;\n    color: white;\n}\n\n.erl-chat .chat-sidebar, .erl-chat .dest-select-window {\n    width: 42px;\n    background-color: #a21236;\n    min-height: 50px;\n    position: absolute;\n    border-radius: 0 4px 4px 0;\n    bottom: 15%;\n    top: auto;\n    transition: transform 0.5s ease;\n}\n\n.erl-chat .chat-sidebar.chat-hidden {\n    transform: translateX(-76%);\n    cursor: pointer;\n}\n\n.erl-chat .chat-icon {\n    opacity: .95;\n    transition: transform 0.2s ease;\n}\n\n.erl-chat .chat-icons {\n    padding: 10px;\n}\n\n.erl-chat .chat-icon:hover {\n    opacity: 1;\n    transform: scale(1.15);\n    position: relative;\n}\n\n.erl-chat .chat-icon, .erl-chat .chat-icon a {\n    color: white;\n    padding: 5px 0;\n    cursor: pointer;\n}\n\n.erl-chat .chat-icon-message {\n    font-size: 21px;\n}\n\n.erl-chat .chat-window.show-chat-window {\n    visibility: visible;\n    opacity: 1;\n}\n\n.erl-chat .chat-icon .right-icon {\n    display: none;\n}\n\n\n.erl-chat .error {\n    color: white;\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n\n.erl-chat .dest-select-window {\n    background-color: #a21236;\n    position: absolute;\n    width: 300px;\n    display: block;\n    right: -250px;\n    color: white;\n    padding: 15px;\n    left: 50px;\n    border-radius: 4px;\n    visibility: hidden;\n    opacity: 0;\n    transition: all .3s ease;\n    max-height: calc(100vh - 100px);\n    bottom: 20px;\n    overflow: auto;\n}\n\n.erl-chat .chat-destination .info-line, .erl-chat .destination-details .info-line {\n    padding: 5px;\n    transition: all .3s ease;\n    background-color: rgba(255, 242, 242, 0);\n    border-radius: 4px;\n}\n\n.erl-chat .chat-destination:hover .info-line, .erl-chat .destination-details:hover .info-line {\n    background-color: rgba(255, 242, 242, 0.2);\n}\n\n.erl-chat .dest-select-window.show-dest-select-window {\n    visibility: visible;\n    opacity: 1;\n}\n\n.erl-chat .dest-link {\n    text-decoration: none;\n    color: white;\n    font-weight: normal;\n}\n\n@media screen and (min-width: 990px) {\n    .erl-chat {\n        position: fixed;\n        left: unset;\n        top: 0;\n        right: 0;\n        z-index: 501;\n    }\n\n    .erl-chat .chat-sidebar, .erl-chat .dest-select-window {\n        border-radius: 4px 0 0 4px;\n        top: 50%;\n        transform: translate(-100%, -50%);\n        bottom: unset;\n    }\n\n    .erl-chat .dest-select-window {\n        left: auto;\n        right: -250px;\n        border-radius: 4px;\n    }\n\n    .erl-chat .chat-sidebar.chat-hidden {\n        transform: translate(-20%, -50%);\n        cursor: pointer;\n    }\n\n    .erl-chat .chat-window {\n        min-width: 400px;\n        width: 100%;\n        left: -410px;\n        top: -60px;\n        bottom: unset;\n        max-height: 93vh;\n    }\n\n    .erl-chat .dest-select-window {\n        bottom: auto;\n        max-height: calc(100vh - 100px);\n        overflow: auto;\n        position: fixed;\n    }\n\n    #top .avia-slideshow-arrows a.next-slide {\n        right: 45px;\n    }\n\n    .erl-chat .chat-icon .right-icon {\n        display: block;\n    }\n\n    .erl-chat .chat-icon .left-icon {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
